import { memo } from 'react';
import { Grid } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItemHeader } from 'components/styles_components/list';
import SortableHeader from 'components/sortable_header';
import useMobile from 'hooks/use_mobile';

const ListHeader = ({ sortBy, onSortChange }) => {
  const isMobile = useMobile();

  if (isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: 6 }} textAlign="left">
          <SortableHeader
            field="name"
            label="name"
            sortBy={sortBy}
            onSortChange={onSortChange}
            textAlign="left"
          />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <FormattedMessage id="inspection.period" />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <FormattedMessage id="inspection.field.count" />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <FormattedMessage id="inspection.count" />
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default memo(ListHeader);
